import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
} from '@chakra-ui/react';
import ProjectPictureApi from '~/common/api/zeiterfassungServerApi/ProjectPictureApi';
import ProjectPicture from '../CreateEditProject/ProjectPicture';
import useTranslate from '~/common/utils/translate';
import React from 'react';

const ProjectPicturePopup: React.FC<{
  projectId: number;
  isOpen: boolean;
  onClose: () => void;
}> = ({ projectId, isOpen, onClose }) => {
  const translate = useTranslate();

  const [{ data: projectPicture }] =
    ProjectPictureApi.hooks.useProjectPictureQuery(
      { id: projectId ?? -1 },
      { enabled: !!projectId },
    );
  return (
    <Box>
      <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {translate('project.createEditProject.projectPicture')}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <ProjectPicture
              initialImage={projectPicture?.picture || null}
              projectId={projectId}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default ProjectPicturePopup;
